import { configureStore } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist';

import rootReducer from './reducer';
import apiClient, { ApiClient } from '../services/ApiClient';
import mockApiClient from '../services/__mock__/ApiClient';
import { crashReporter, logger } from '../logging/reduxMiddleware';

/**
 * If using Redux-Persist, you should specifically ignore all the action types it dispatches as per the
 * Redux Toolkit documentation: https://redux-toolkit.js.org/usage/usage-guide#use-with-redux-persist
 */

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    const middlewares = getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      thunk: {
        extraArgument: {
          get apiClient() {
            return store.getState().user.isMockUser ? mockApiClient : apiClient;
          },
        },
      },
    });
    middlewares.push(logger);
    middlewares.push(crashReporter);
    return middlewares;
  },
});

export type RootState = ReturnType<typeof rootReducer>;
export const persistor = persistStore(store);
export type AppDispatch = typeof store.dispatch;
export type Store = typeof store;
export default store;
export type ThunkExtra = { apiClient: ApiClient };
